const checkBlacklistResultAfterPaid = async (profileState, checkAndRemoveBlacklistIfNeeded) => {
  try {
    const result = await checkAndRemoveBlacklistIfNeeded(profileState.id);
    if (result.removed) {
      console.log("NOT BLACK LIST ANYMORE");
      alert("ลบ ❌❌ จาก chatcone");
    } else if (result.error) {
      console.log("ERROR:", result.error);
    } else {
      console.log('Customer was not removed from blacklist (either not blacklisted or unpaid percentage still > 70%)');
    }
  } catch (error) {
    console.log("ERROR:", error);
  }
};

export default checkBlacklistResultAfterPaid;
